import React from 'react';
import styled from 'styled-components';
import { Link, Text, Icon } from '@amzn/storm-ui';
import { angleInlineStart } from '@amzn/storm-ui-icons';
import { getClickEventHandler } from '../../../../commons/utils';
import type { Breadcrumb as BreadcrumbType } from '../../../../app/slice';

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
  & svg {
    color: ${({ theme }) => theme.palette.white};
    opacity: 0.3;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  background-color: ${({ theme }) => theme.palette.shuttle};
  padding: ${({ theme }) => theme.mobile.spacing.small};
  align-items: center;
  &&& {
    color: ${({ theme }) => theme.palette.white};
    text-decoration: none;
  }
`;

const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledIcon = styled(Icon)`
  margin-inline-end: ${({ theme }) => theme.mobile.spacing.small};
`;

interface MobileBreadcrumbProps {
  breadcrumb: BreadcrumbType;
}

const MobileBreadcrumb: React.VFC<MobileBreadcrumbProps> = ({ breadcrumb }) => {
  const eventHandler = getClickEventHandler(breadcrumb);
  const { label, url, objectType } = breadcrumb;
  return (
    <StyledLink href={url} onClick={eventHandler}>
      <StyledIcon type={angleInlineStart} blockSize />
      <StyledText type="span" fontSize="small">
        {objectType ? `${objectType}: ${label}` : label}
      </StyledText>
    </StyledLink>
  );
};

export default MobileBreadcrumb;
